// src/api/customerApi.js
import axiosClient from "./axiosClient";

const customerApi = {
  // THÊM THAM SỐ page VÀ pageSize VÀO searchCustomers
  searchCustomers: (searchKeyword = "", page = 0, pageSize = 10) => {
    const params = new URLSearchParams();
    if (!searchKeyword) {
      searchKeyword = "";
    }
    params.append("searchKeyword", searchKeyword);
    params.append("pageNumber", page > 0 ? page + 1 : 1); // +1 do page của datagrid bắt đầu từ 0
    params.append("pageSize", pageSize);
    return axiosClient.get(`/customers/search?${params.toString()}`, {
      withCredentials: true,
    });
  },

  upsertCustomer: (customerData) => {
    return axiosClient.post("/customers/upsert", customerData, {
      withCredentials: true,
    });
  },

  deleteCustomer: (customerId) => {
    return axiosClient.delete(`/customers/${customerId}`, {
      withCredentials: true,
    });
  },
  getCustomerInfor: (customerId) => {
    return axiosClient.get(`/customers/get-customer-infor/${customerId}`, {
      withCredentials: true,
    });
  },
  getCustomerInforByTaxCode: (taxCode) => {
    return axiosClient.get(
      `/customers/get-customer-infor-by-tax-code/${taxCode}`,
      {
        withCredentials: true,
      },
    );
  },
  getCustomerInforByGuid: (customerNo) => {
    return axiosClient.get(
      `/customers/get-customer-infor-by-guid/${customerNo}`,
      {
        withCredentials: true,
      },
    );
  },
  linkParentCustomer: (isLink, customerId, customerParentId) => {
    return axiosClient.post(
      `/customers/link-parent-customer`,
      {
        isLink: isLink,
        customerId: customerId,
        customerParentId: customerParentId,
      },
      {
        withCredentials: true,
      },
    );
  },
  getCustomerRelationship: (customerId) => {
    return axiosClient.post(
      `/customers/get-customer-relationship`,
      {
        customerId: customerId,
      },
      {
        withCredentials: true,
      },
    );
  },
  getCustomerByUser: (userId) => {
    return axiosClient.post(
      `/customers/get-customer-by-user`,
      {
        userId: userId,
      },
      {
        withCredentials: true,
      },
    );
  },
};

export default customerApi;
